import React from 'react';
import "./style.scss";

export default function({customStyle}) {
    return <hr className={`customDivider`} style={customStyle}/>
} 